export default "__VITE_ASSET__DxDKTv9H__"